<template>
  <div id="app" class="has-background-white">
    <b-progress
     
      id="app-loader"
      v-if="loading"
    ></b-progress>
    <section v-else-if="error" class="hero is-fullheight is-dark is-bold">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">{{ error }}</h1>
          <button @click="retry()" class="button is-light">RETRY</button>
        </div>
      </div>
    </section>
    <section
      v-else-if="!accepted"
      
      class="hero has-text-dark is-fullheight is-bold"
    >
      <div class="hero-body">
        <div class="container">
          <div class="content">
            <h1 class="title has-text-white">ANNOUNCEMENT</h1>
            <p class="text-centered">
            Tambola is a skill based game considered by supreme court of India. {{$store.state.info.name}}
            is completely legal (except in case of assam and odisha) and has been designed by 
            strictly following the set of rules stated by indian governing law and jurisdiction.
            At the same time it is legally registered with the appropriate registration authorities.

            <ul style="margin-top:25px;text-align:left">
              <li>None of the employee/agents/director/partner can participate in the game.</li>
              <li>The company will redraw the game incase of server fault or any technical problem on server side during the draw.</li>
              <li>Incase of redraw, no payment will be made on behalf of faulting draw.</li>
              <li>Cancellation of tickets will not be entertained, if there is redraw in the game.</li>
            </ul>

            </p>
          </div>
          <div class="content">
            <h1 class="title has-text-white">DECLARATION</h1>
            <p class="text-centered">
             I declare that i am a citizen of India. I am not a domicile of state of assam / odisha / telengana. <br />
             I am 18+ years of age as of today. I am not an employee / director / partner of {{$store.state.info.name}}.
            </p>
          </div>
          <button
            @click="accept()"
            style="
              max-width: 60%;
              margin: auto;
              color: #000;
            "
            class="button is-medium has-background-primary has-text-white is-fullwidth  is-outlined"
          >
            START THE GAME
          </button>
        </div>
      </div>
    </section>
    <router-view v-else />
    <notifications group="global" />
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";

export default {
  data() {
    return {
      error: null,
      fetchingInfo: true,
      loading: true,
      accepted: false,
    };
  },
  async created() {
    try {
      this.$store.dispatch("fetchInfo").then(() => {});
      let route = await this.$store.dispatch("fetchStatus");
      firebase.auth().onAuthStateChanged(async (user) => {
        this.loading = false;
        if (this.$route.name !== "Admin" && this.$route.name !== "Login") {
          this.$router.push(route);
        } else {
          if (user) {
            this.accept()
            this.$store.commit("SET_USER", user);
          }
        }
      });
    } catch (error) {
      //
      console.log(error);
      this.loading = false;
      this.error = "Something went Wrong!";
    }
  },
  methods: {
    retry() {
      window.location.href = "/";
    },
    accept() {
      this.accepted = true;
    },
  },
};
</script>

<style>
.green-background {
  background: #03134b !important;
}
.page-header {
  font-size: 30px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  text-transform: uppercase;
  font-weight: 400;
  font-family: "Audiowide", cursive;
  color: #ecf3f7;

}
#app {
  font-family: "Gill Sans", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  font-weight: bolder;
}
#app-loader {
  position: fixed;
  left: 50%;
  top: 50%;
  width: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
